module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/CoverSection/theft-405c87cc07aada108fa9ddc9db21698c.png";